'use client'

import { useState } from 'react'
import { cn } from '@/lib/utils'
import type { CustomerBrand } from '@/lib/api/site'

type BrandTileProps = {
  brand: CustomerBrand
  className?: string
  logoClassName?: string
  labelClassName?: string
  fallbackClassName?: string
  forceText?: boolean
}

export function BrandTile({
  brand,
  className,
  logoClassName,
  labelClassName = 'text-xs font-bold text-charcoal-800 text-center px-2 line-clamp-2',
  fallbackClassName = 'bg-white',
  forceText,
}: BrandTileProps) {
  const [failed, setFailed] = useState(false)
  const logoUrl = brand.logoUrl?.trim()
  const showImage = !forceText && Boolean(logoUrl) && !failed

  return (
    <div
      className={cn(
        'h-20 bg-white rounded-sm shadow-sm flex items-center justify-center p-3 transition-colors overflow-hidden',
        className,
        !showImage && fallbackClassName,
      )}
    >
      {showImage && logoUrl ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={logoUrl}
          alt={brand.name}
          title={brand.name}
          onError={() => setFailed(true)}
          className={cn('max-h-12 max-w-full w-auto object-contain', logoClassName)}
        />
      ) : (
        <span className={labelClassName}>{brand.name}</span>
      )}
    </div>
  )
}


